module.exports = __webpack_public_path__ + "static/TT2-evergreen-page-screening-sales-when-iStock-667078838.9c07b3c5.jpg";